// src/config/app.js
//
// The companion mobile app this site hands off to. Set comingSoon:false and
// fill in the store URLs when it launches, and every link across the site
// updates.

export const COMPANION = {
  name: "the Filtspot app",
  shortName: "Filtspot app",
  tagline: "Measures the light in front of you and returns the filter for it",
  // The app isn't out yet. While true, store buttons show "Coming soon"
  // instead of linking to placeholder listings.
  comingSoon: true,
  // Fill these in when the app launches, then set comingSoon:false.
  appStoreUrl: "",
  playStoreUrl: "",
  siteUrl: "https://filtspot.com",
};

/**
 * What the app does that this site structurally cannot.
 *
 * Worth being precise about, because the honest version is a better
 * argument than the vague one. This site computes from a lighting
 * CATEGORY — "full sun" is defined as EV 15, and every number on a
 * full-sun page follows from that assumption. Real full sun is not always
 * EV 15. Thin high cloud, a light-coloured wall bouncing fill, late
 * afternoon in a city street: all still "full sun" to a person choosing
 * from a dropdown, all measurably different light.
 *
 * A meter closes that gap by measuring instead of assuming. That is a real
 * difference in kind, not a feature list.
 */
export const COMPANION_POINTS = [
  "Measures the actual light rather than assuming a category",
  "Labels every reading by how much to trust it",
  "Covers 142 cameras and drones with their real apertures and log profiles",
];
